module.exports = __webpack_public_path__ + "img/ghpd2.74bf35e0.png";